import React, { useState, useCallback } from "react";
import {
  Box,
  Typography,
  IconButton,
  Stack,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from 'react-redux'
import { notificationSuccess } from '../../state/Action/NotificationAction'

function FileUpload({
  label,
  setShow1,
  files,
  setFiles,
  deleteImage,
  setDeleteImage,
}) {
  const [dragging, setDragging] = useState(false);
  const dispatch = useDispatch();
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    if (selectedFiles && selectedFiles[0]?.size > 5 * 1024 * 1024) {
      dispatch(notificationSuccess({
        show: true,
        type: 'error',
        message: "Please select file below 5MB"
      }));
      return;
    }

    if (selectedFiles) {
      const file = selectedFiles[0];
      setFiles((prev) => [...prev, { image: file }]);
    }
  };

  const handleDragEnter = useCallback((event) => {
    event.preventDefault();
    setDragging(true);
  }, []);

  const handleDragLeave = useCallback((event) => {
    event.preventDefault();
    setDragging(false);
  }, []);

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
  }, []);

  const handleDrop = useCallback(
    (event) => {
      event.preventDefault();
      setDragging(false);

      const droppedFiles = event.dataTransfer.files;
      if (droppedFiles && droppedFiles[0]?.size > 5 * 1024 * 1024) {
        dispatch(notificationSuccess({
          show: true,
          type: 'error',
          message: "Please select file below 5MB"
        }));
        return;
      }

      if (droppedFiles.length) {
        setFiles((prev) => [...prev, { image: droppedFiles[0] }]);
      }
    },
    [setFiles]
  );

  const handleRemoveFile = (index, file) => {
    if (file?.id) {
      setDeleteImage((prev) => [...prev, file.id]);
    }
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <Box>
      {label && (
        <Typography fontSize={16} fontWeight={500} mb={"2px"}>
          {label}
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
          width: "100%",
        }}
      >
        {/* Drag-and-Drop Box */}
        <label htmlFor="file-upload-input">
          <Box
            sx={{
              width: { xs: "100%", md: "400px" },
              height: 70,
              border: "1px dashed #c4c4c4",
              borderRadius: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: dragging ? "#e0e0e0" : "#f8f8f8",
              cursor: "pointer",
              transition: "background 0.3s ease",
              fontSize: '14px',
              fontWeight: '600',
            }}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            Drop your files here or click to browse
            <input
              id="file-upload-input"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </Box>
        </label>

        {/* File Previews */}
        <Stack direction="row" flexWrap="wrap" gap={2}>
          {files?.map((file, index) => (
            <Box
              key={index}
              sx={{
                position: "relative",
                width: 100,
                height: 70,
                border: "1px solid #e3e3e3",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <IconButton
                sx={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  zIndex: 1,
                }}
                onClick={() => handleRemoveFile(index, file)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
              <img
                src={file.id ? file.image : URL.createObjectURL(file.image)}
                alt={`File preview ${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}

export default FileUpload;

